export function SiteFilingFooter() {
  return (
    <footer className="site-filing">
      <span>PPT工作台</span>
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        苏ICP备2026032473号-1
      </a>
    </footer>
  );
}
